import { Controller } from "stimulus";

// Collapses a long class note to two clamped lines and reveals a "Ver mais"
// toggle only when the content actually overflows. The notes panel lives in a
// hidden tab, so overflow is measured via IntersectionObserver once it shows
// (a hidden element reports zero height and would hide the toggle by mistake).
export default class extends Controller {
  static targets = ["content", "toggle", "label", "chevron"];

  connect() {
    this.collapsed = true;
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting))
        this.refreshToggle();
    });
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  refreshToggle() {
    let content = this.contentTarget,
      overflows = content.scrollHeight > content.clientHeight + 1;

    this.toggleTarget.classList.toggle("hidden", !overflows);
  }

  toggle() {
    this.collapsed = !this.collapsed;
    this.contentTarget.classList.toggle("line-clamp-2", this.collapsed);
    this.labelTarget.textContent = this.collapsed ? "Ver mais" : "Ver menos";
    this.chevronTarget.classList.toggle("rotate-180", !this.collapsed);
  }
}
